import store from '../../store'
export default {

  name: '添易广告投放平台',
  requestUrl: process.env.VUE_APP_API_BASE_URL,

  // *************************************************************************
  // 版权
  copyright: {
    text1: 'CopyRight  2014 - ',
    text2: ' 深圳市易乐云科技有限公司 版权所有',
    text3: '粤ICP备17164067号'
  },
  // 托管登录
  trusteeshipApi: '/trust',
  // 权限接口模块
  houseModule: {
    in: {
      id: 1502,
      number: '/rptieda/selectSspUserHomePage',
      chart: '/rptieda/selectSspUserVision',
      top: '/rptieda/selectTopConsume'
    },
    out: {
      id: 1501,
      number: '/rptieda/selectAdvertiserHomePage',
      chart: '/rptieda/selectAdvertiserVision'
    }
  },
  requestModule: {
    // 用户管理
    user: {
      name: '用户管理',
      children: {
        // 广告主列表
        adOwner: {
          name: '广告主',
          id: 1300,
          power: 1,
          children: {
            list: {
              name: '查询广告主信息列表',
              id: 1301,
              power: 2,
              api: '/advertiser/query/list'
            },
            detail: {
              name: '查询广告主信息详情',
              id: 1302,
              power: 4,
              api: '/advertiser/query/info'
            },
            add: {
              name: '新增广告主',
              id: 1303,
              power: 8,
              api: '/advertiser/add/info',
              exists: '/advertiser/query/name/exists'
            },
            delete: {
              name: '删除广告主',
              id: 1304,
              power: 16,
              api: '/advertiser/delete/info'
            },
            modify: {
              name: '修改广告主',
              id: 1305,
              power: 32,
              api: '/advertiser/update/info',
              exists: '/advertiser/query/name/exists'
            },
            balance: {
              name: '充值/退款',
              id: 1306,
              power: 64,
              api: '/advertiser/update/balance'
            },
            balanceDetail: {
              name: '充值/退款记录',
              id: 1307,
              power: 128,
              api: '/advertiser/query/balanceDetail'
            }
          }
        },
        // 广告主账号列表
        adUser: {
          name: '广告主账号',
          id: 100,
          power: 1,
          children: {
            list: {
              name: '查询广告主账号信息列表',
              id: 101,
              power: 2,
              api: '/user/query/list',
              adowner: '/advertiser/query/list'
            },
            detail: {
              name: '查询广告主账号信息详情',
              id: 102,
              power: 4,
              api: '/user/query/info'
            },
            add: {
              name: '新增广告主账号',
              id: 103,
              power: 8,
              api: '/user/add/info',
              exists: '/user/query/name/exists',
              role: '/role/query/list',
              adowner: '/advertiser/query/list'
            },
            delete: {
              name: '删除广告主账号',
              id: 104,
              power: 16,
              api: '/user/delete/info'
            },
            modify: {
              name: '修改广告主账号',
              id: 105,
              power: 32,
              api: '/user/update/info',
              exists: '/user/query/name/exists',
              role: '/role/query/list',
              adowner: '/advertiser/query/list'
            },
            status: {
              name: '启用/禁用广告主账号',
              id: 106,
              power: 64,
              api: '/user/update/status'
            }
          }
        },
        // 媒体主列表
        medOwner: {
          name: '内部账号',
          id: 200,
          power: 1,
          children: {
            list: {
              name: '查询内部账号信息列表',
              id: 201,
              power: 2,
              api: '/user/query/list'
            },
            detail: {
              name: '查询内部账号信息详情',
              id: 202,
              power: 4,
              api: '/user/query/info'
            },
            modify: {
              name: '修改内部账号',
              id: 203,
              power: 8,
              api: '/user/update/info',
              role: '/role/query/list'
            }
          }
        },
        // 角色
        role: {
          name: '角色',
          id: 300,
          power: 1,
          children: {
            list: {
              name: '查询角色信息列表',
              id: 301,
              power: 2,
              api: '/role/query/list'
            },
            detail: {
              name: '查询角色信息详情',
              id: 302,
              power: 4,
              api: '/role/query/info'
            },
            add: {
              name: '新增角色',
              id: 303,
              power: 8,
              api: '/role/add/info',
              exists: '/role/query/name/exists'
            },
            delete: {
              name: '删除角色',
              id: 304,
              power: 16,
              api: '/role/delete/info'
            },
            modify: {
              name: '修改角色',
              id: 305,
              power: 32,
              api: '/role/update/info',
              exists: '/role/query/name/exists'
            }
          }
        }
      }
    },
    // 日志管理
    log: {
      name: '日志管理',
      id: 400,
      power: 1,
      children: {
        login: {
          name: '登录日志',
          id: 401,
          power: 2,
          api: '/log/query/login'
        },
        operate: {
          name: '操作日志',
          id: 402,
          power: 4,
          api: '/log/query/operate'
        }
      }
    },
    // 投放计划
    plan: {
      name: '投放计划管理',
      id: 1100,
      power: 1,
      children: {
        list: {
          name: '查询投放计划列表',
          id: 1101,
          power: 2,
          api: '/plan/query/list',
          user: '/advertiser/query/list'
        },
        detail: {
          name: '查询投放计划信息',
          id: 1102,
          power: 4,
          api: '/plan/query/info'
        },
        add: {
          name: '新增投放计划',
          id: 1103,
          power: 8,
          api: '/plan/add/info',
          exists: '/plan/query/name/exists',
          user: '/advertiser/query/list'
        },
        delete: {
          name: '删除投放计划',
          id: 1104,
          power: 16,
          api: '/plan/delete/info'
        },
        modify: {
          name: '修改投放计划',
          id: 1105,
          power: 32,
          api: '/plan/update/info',
          exists: '/plan/query/name/exists',
          user: '/advertiser/query/list'
        },
        status: {
          name: '启用/禁用投放计划',
          id: 1106,
          power: 64,
          api: '/plan/update/status'
        }
      }
    },
    // 投放单元管理
    unit: {
      name: '投放单元管理',
      id: 500,
      power: 1,
      children: {
        list: {
          name: '查询投放单元信息列表',
          id: 501,
          power: 2,
          api: '/putunit/query/list',
          user: '/advertiser/query/list',
          plan: '/plan/query/list'
        },
        detail: {
          name: '查询投放单元信息详情',
          id: 502,
          power: 4,
          api: '/putunit/query/info'
        },
        add: {
          name: '新增投放单元',
          id: 503,
          power: 8,
          api: '/putunit/add/info',
          exists: '/putunit/query/name/exists',
          user: '/advertiser/query/list',
          plan: '/plan/query/list'
        },
        delete: {
          name: '删除投放单元',
          id: 504,
          power: 16,
          api: '/putunit/delete/info'
        },
        modify: {
          name: '修改投放单元',
          id: 505,
          power: 32,
          api: '/putunit/update/info',
          exists: '/putunit/query/name/exists',
          user: '/advertiser/query/list',
          plan: '/plan/query/list'
        },
        status: {
          name: '启用/禁用投放单元',
          id: 506,
          power: 64,
          api: '/putunit/update/status'
        }
      }
    },
    // 创意类型
    ideaType: {
      name: '创意类型管理',
      id: 600,
      power: 1,
      children: {
        list: {
          name: '查询创意类型列表',
          id: 601,
          power: 2,
          api: '/ideatype/query/list'
        },
        detail: {
          name: '查询创意类型详情',
          id: 602,
          power: 4,
          api: '/ideatype/query/info'
        },
        add: {
          name: '新增创意类型',
          id: 603,
          power: 8,
          api: '/ideatype/add/info',
          exists: '/ideatype/query/name/exists'
        },
        delete: {
          name: '删除创意类型',
          id: 604,
          power: 16,
          api: '/ideatype/delete/info'
        },
        modify: {
          name: '修改创意类型',
          id: 605,
          power: 32,
          api: '/ideatype/update/info',
          exists: '/ideatype/query/name/exists'
        },
        status: {
          name: '启用/禁用创意类型',
          id: 606,
          power: 64,
          api: '/ideatype/update/status'
        }
      }
    },
    // 创意
    idea: {
      name: '创意管理',
      id: 700,
      power: 1,
      children: {
        list: {
          name: '查询创意列表',
          id: 701,
          power: 2,
          api: '/idea/query/list',
          type: '/ideatype/query/list',
          unit: '/putunit/query/list',
          plan: '/plan/query/list',
          user: '/advertiser/query/list'
        },
        detail: {
          name: '查询创意详情',
          id: 702,
          power: 4,
          api: '/idea/query/info'
        },
        add: {
          name: '新增创意',
          id: 703,
          power: 8,
          api: '/idea/add/info',
          exists: '/idea/query/name/exists',
          type: '/ideatype/query/list',
          unit: '/putunit/query/list',
          user: '/advertiser/query/list'
        },
        delete: {
          name: '删除创意',
          id: 704,
          power: 16,
          api: '/idea/delete/info'
        },
        modify: {
          name: '修改创意',
          id: 705,
          power: 32,
          api: '/idea/update/info',
          exists: '/idea/query/name/exists',
          type: '/ideatype/query/list',
          unit: '/putunit/query/list',
          user: '/advertiser/query/list'
        },
        status: {
          name: '启用/禁用创意',
          id: 706,
          power: 64,
          api: '/idea/update/status'
        },
        audit: {
          name: '审核/封禁',
          id: 707,
          power: 128,
          // 包括 /idea/disable
          api: '/idea/verify'
        }
      }
    },
    // 缓存管理
    cache: {
      name: '缓存管理',
      id: 800,
      power: 1,
      children: {
        refresh: {
          name: '刷新缓存',
          id: 801,
          power: 2,
          api: '/cache/flushCache'
        }
      }
    },
    // 报表
    chart: {
      name: '报表管理',
      id: 900,
      power: 1,
      children: {
        adOnwer: {
          name: '广告主报表',
          id: 901,
          power: 2,
          api: '/rptieda/selectRptIdeaList',
          user: '/advertiser/query/list',
          export: '/rptieda/exportRptIdeaList'
        },
        unit: {
          name: '投放单元报表',
          id: 902,
          power: 4,
          api: '/rptieda/selectRptIdeaList',
          user: '/advertiser/query/list',
          unit: '/putunit/query/list',
          export: '/rptieda/exportRptIdeaList'
        },
        idea: {
          name: '创意报表',
          id: 903,
          power: 8,
          api: '/rptieda/selectRptIdeaList',
          user: '/advertiser/query/list',
          unit: '/putunit/query/list',
          idea: '/idea/query/list',
          export: '/rptieda/exportRptIdeaList'
        },
        report: {
          name: '报告总览（内部用户）',
          id: 904,
          power: 16,
          api: '/rptieda/selectTotalPage',
          export: '/rptieda/exportTotalPage'
        },
        finance: {
          name: '财务统计（内部用户）',
          id: 905,
          power: 32,
          api: '/rptieda/selectFinancePage',
          export: '/rptieda/exportFinancePage',
          adowner: '/advertiser/query/list'
        },
        advert: {
          name: '广告统计（内部用户）',
          id: 906,
          power: 64,
          api: '/rptieda/selectAdStatisPage',
          export: '/rptieda/selectAdStatisPage',
          adowner: '/advertiser/query/list',
          ideatype: '/ideatype/query/list'
        },
        flow: {
          name: '流量统计（内部用户）',
          id: 907,
          power: 128,
          api: '/rptieda/selectFlowStatisPage',
          export: '/rptieda/exportFlowStatisPage'
        },
        pkg: {
          name: '包名报表',
          id: 908,
          power: 256,
          api: '/rptieda/selectRptIdeaPkgList',
          export: '/rptieda/exportRptIdeaPkgList',
          user: '/advertiser/query/list',
          unit: '/putunit/query/list',
          idea: '/idea/query/list'
        },
        slot_pkg: {
          name: '代码位包名报表',
          id: 909,
          power: 512,
          api: '/rptieda/selectRptIdeaSlotPkgList',
          export: '/rptieda/exportRptIdeaSlotPkgList',
          user: '/advertiser/query/list',
          unit: '/putunit/query/list',
          idea: '/idea/query/list'
        }
      }
    },
    // 日志流
    logStream: {
      name: '日志流管理',
      id: 1000,
      power: 1,
      children: {
        report: {
          name: '广告上报日志',
          id: 1001,
          power: 2,
          api: '/aliyunlog/list/adClientReportedInfo'
        },
        request: {
          name: '广告请求日志',
          id: 1002,
          power: 4,
          api: '/aliyunlog/list/adRequestInfo'
        },
        response: {
          name: '广告响应日志',
          id: 1003,
          power: 8,
          api: '/aliyunlog/list/adResponseInfo'
        }
      }
    },
    // ADX管理
    adx: {
      name: 'ADX管理',
      id: 1200,
      power: 1,
      children: {
        list: {
          name: '查询ADX列表',
          id: 1201,
          power: 2,
          api: '/adx/query/list'
        },
        detail: {
          name: '查询ADX信息',
          id: 1202,
          power: 4,
          api: '/adx/query/info'
        },
        add: {
          name: '新增ADX',
          id: 1203,
          power: 8,
          api: '/adx/add/info',
          exists: '/adx/query/name/exists'
        },
        delete: {
          name: '删除ADX',
          id: 1204,
          power: 16,
          api: '/adx/delete/info'
        },
        modify: {
          name: '修改ADX',
          id: 1205,
          power: 32,
          api: '/adx/update/info',
          exists: '/adx/query/name/exists'
        },
        status: {
          name: '启用/禁用ADX',
          id: 1206,
          power: 64,
          api: '/adx/update/status'
        }
      }
    },
    monitor: {
      name: '实时监控（内部用户）',
      id: 1400,
      power: 1,
      children: {
        chart: {
          name: '查询实时监控列表',
          id: 1401,
          power: 2,
          api0: '/monitor/selectMonitorReq',
          api1: '/monitor/selectMonitorBid',
          api2: '/monitor/selectMonitorShow',
          api3: '/monitor/selectMonitorClick',
          api4: '/monitor/selectMonitorConsume'
        }
      }
    },
    operate: {
      name: '运营配置',
      id: 1600,
      power: 1,
      children: {
        list: {
          name: '查询运营配置',
          id: 1601,
          power: 2,
          api: '/operationConfig/query/list'
        },
        update: {
          name: '修改运营配置',
          id: 1602,
          power: 4,
          api: '/operationConfig/update/info'
        }
      }
    },
    sysConfig: {
      name: '系统配置',
      id: 1700,
      power: 1,
      children: {
        list: {
          name: '查询系统配置',
          id: 1701,
          power: 2,
          api1: '/sysConfig/query/all',
          api2: '/sysConfig/query/info'
        },
        update: {
          name: '修改系统配置',
          id: 1702,
          power: 4,
          api: '/sysConfig/update/info'
        }
      }
    }
  },
  // 缓存字段
  storage: {
    // store
    user: 'USER',
    // 习惯记忆
    memory: 'MEMORY'
  },
  // 页码
  pageSize: {
    max: 9999999,
    arr: [10, 20, 50, 100, 200]
  },
  // 代码位类型
  slotType: [
    {id: 1, name: '横幅广告'},
    {id: 3, name: '开屏广告'},
    {id: 5, name: '信息流广告'},
    {id: 7, name: '激励视频广告'},
    // {id: 8, name: '自动拉活广告'},
    {id: 12, name: 'BDA广告'},
    {id: 14, name: 'RTA拉新'}
  ],
  // 状态
  status: [
    {id: '', name: '不限'},
    {id: 1, name: '启用'},
    {id: 0, name: '禁用'}
  ],
  // 创意素材类型
  ideaType: [
    {id: 1, name: 'Icon'},
    {id: 2, name: 'Logo'},
    {id: 3, name: '主图片'},
    {id: 4, name: '图片二'},
    {id: 5, name: '图片三'},
    {id: 6, name: '标题'},
    {id: 7, name: '描述'},
    {id: 8, name: '评分'},
    {id: 9, name: '好评数'},
    {id: 10, name: '落地页链接'},
    {id: 11, name: 'APP名称'},
    {id: 12, name: 'APP下载链接'},
    {id: 13, name: '打开应用URL'},
    {id: 14, name: 'APP包名'},
    {id: 15, name: '展示监控'},
    {id: 16, name: '点击监控'},
    {id: 17, name: '视频'},
    {id: 18, name: 'APP版本'},
    {id: 19, name: 'APP开发者'},
    {id: 20, name: 'APP功能描述URL'},
    {id: 21, name: 'APP隐私政策URL'},
    {id: 22, name: 'APP权限列表URL'},
    {id: 23, name: '下载开始监控'},
    {id: 24, name: '下载完成监控'},
    {id: 25, name: '安装开始监控'},
    {id: 26, name: '安装完成监控'}
  ],
  // 禁用状态值
  is: {
    true: 1,
    false: 0
  },
  selectNull: [
    {id: '', name: '忽略'},
    {id: 0, name: '不限'}
  ],
  selectAll: [
    {id: '', name: '不限'}
  ],
  selectwhole: [
    {id: '', name: '全部'}
  ],
  // 出价类型
  bidType: [
    {id: 1, name: '每个唤醒成本'},
    {id: 2, name: 'CPC'},
    {id: 3, name: 'CPM'},
    {id: 4, name: 'oCPM'},
    {id: 5, name: 'oCPC'}
  ],
  // 拉活触发策略
  triggerWay: [
    {id: 1, name: '定时'},
    {id: 2, name: '进入锁屏'}
  ],
  // 定时触发策略
  timeWay: [
    {id: 1, name: '定速'},
    {id: 2, name: '时间段随机'}
  ],
  // 动作类型
  actionType: [
    {id: '', name: '不限'},
    {id: 1, name: '展示'},
    {id: 2, name: '点击'},
    {id: 3, name: '下载开始'},
    {id: 4, name: '下载完成'},
    {id: 5, name: '安装开始'},
    {id: 6, name: '安装完成'},
    {id: 7, name: '通过包名打开'},
    {id: 8, name: '应用唤醒'},
    {id: 9, name: '播放开始'},
    {id: 10, name: '播放中断'},
    {id: 11, name: '播放结束'},
    {id: 12, name: '广告跳过'},
    {id: 13, name: '广告被关闭'},
    {id: 14, name: '全屏播放'},
    {id: 15, name: '点击预览图播放'},
    {id: 16, name: '激活'},
    {id: 17, name: '注册'},
    {id: 18, name: '登录'},
    {id: 19, name: '下单支付'},
    {id: 20, name: '唤醒成功'},
    {id: 21, name: '加桌'},
    {id: 22, name: '关键行为'}
  ],
  // 设备类型
  deviceType: [
    {id: 0, name: 'Unknow'},
    {id: 1, name: 'Phone/手机'},
    {id: 2, name: 'Tablet/平板'},
    {id: 3, name: 'TV/智能电视'}
  ],
  // 运营商
  mccmnc: [
    {id: 46000, name: '中国移动'},
    {id: 46002, name: '中国移动'},
    {id: 46007, name: '中国移动'},
    {id: 46001, name: '中国联通'},
    {id: 46006, name: '中国联通'},
    {id: 46003, name: '中国电信'},
    {id: 46005, name: '中国电信'}
  ],
  // 操作系统
  osType: [
    {id: 0, name: 'Unknows'},
    {id: 1, name: 'Android'},
    {id: 2, name: 'IOS'},
    {id: 3, name: 'Windows'}
  ],
  // 网络类型
  connType: [
    {id: 0, name: 'Unknown'},
    {id: 1, name: 'Wifi'},
    {id: 2, name: '2G'},
    {id: 3, name: '3G'},
    {id: 4, name: '4G'},
    {id: 5, name: '5G'}
  ],
  // 协议类型
  protocolType: [
    {id: 1, name: '营销云ADX'}
  ],
  // 创意类型归属
  createType: [
    {id: 0, name: '自主创建'},
    {id: 1, name: '系统内置'}
  ],
  // 流量类型
  flowType: [
    {id: 1, name: 'Android App'},
    {id: 2, name: 'Wap'},
    {id: 3, name: 'IOS App'},
    {id: 4, name: 'Web'},
    {id: 5, name: 'HarmonyOS'}
  ],
  macroList: [
    {name: '__REQUEST_ID__', desc: '请求ID', required: 0},
    {name: '__IP__', desc: '用户IP', required: 0},
    {name: '__UA__', desc: '设备User-Agent', required: 0},
    {name: '__VENDOR__', desc: '设备品牌', required: 0},
    {name: '__MODEL__', desc: '设备机型', required: 0},
    {name: '__CONN_TYPE__', desc: '设备网络类型((Unknown=0; Wifi=1; 2G=2; 3G=3; 4G=4; 5G=5))', required: 0},
    {name: '__DEVICE_TYPE__', desc: '设备类型(Unknown=0; Phone/手机=1；Tablet/平板=2；TV/智能电视=3)', required: 0},
    {name: '__OS_TYPE__', desc: '设备的操作系统类型(Unknows=0；Android=1；IOS=2；Windows=3)', required: 0},
    {name: '__OS_VERSION__', desc: '设备 OS 版本', required: 0},
    {name: '__IMEI__', desc: '设备(安卓) IMEI，备注：__IMEI__和__IMEI_MD5__二选一即可', required: 0},
    {name: '__IMEI_MD5__', desc: '设备(安卓) IMEI的 MD5 (大写)，备注：__IMEI__和__IMEI_MD5__二选一即可', required: 0},
    {name: '__ANDROID_ID__', desc: '设备(安卓) Android ID，备注：__ANDROID_ID__和__ANDROID_ID_MD5__二选一即可', required: 0},
    {name: '__ANDROID_ID_MD5__', desc: '设备(安卓) Android ID的 MD5 (大写)，备注：__ANDROID_ID__和__ANDROID_ID_MD5__二选一即可', required: 0},
    {name: '__IDFA__', desc: '设备(iOS) IDFA', required: 0},
    {name: '__OAID__', desc: '设备 OAID (匿名设备标识符)', required: 0},
    {name: '__CAID__', desc: '设备 CAID (广告标识)，格式：url_encode(ver1_caid1,ver2_caid2)', required: 0},
    {name: '__MAC__', desc: '设备 MAC', required: 0},
    {name: '__MCCMNC__', desc: '设备国家/网络代码', required: 0},
    {name: '__DPI__', desc: '设备 DPI (每英寸点数)', required: 0},
    {name: '__ADVERTISER_ID__', desc: '广告主 ID', required: 0},
    {name: '__APID__', desc: '投放计划 ID', required: 0},
    {name: '__AUID__', desc: '投放单元 ID', required: 0},
    {name: '__CID__', desc: '创意 ID', required: 0},
    {name: '__CALLBACK__', desc: '转化回传地址，注意事项：1. 使用时需先进行url解码；2.需要替换宏参数 __EVENT_TYPE__，__EVENT_TIME__', required: 1},
    {name: '__TS__', desc: '客户端触发监测的时间。UTC 时间戳, 单位为秒', required: 0}
  ],
  // ****************************************
  // 异常响应编码
  abnormalCode (_this, code) {
    let logout = false
    let update = false
    let abnormal = false
    let text = ''
    switch (code) {
      case 400: text = '参数有误'; break
      case 1000: text = '操作失败，请刷新重试'; break
      case 1001: text = '身份校验失败，请重新登录'; logout = true; break
      case 1003: text = '权限校验失败，请重新登录'; logout = true; break
      case 1004: text = '数据存在绑定关系'; break
      case 1005: text = '旧密码有误，请重新输入'; break
      case 1006: text = '退款失败：账户余额不足'; break
      default: text = '未知错误，请联系平台管理人员'; abnormal = true
    }
    _this.$message.error(text)
    if (logout) {
      setTimeout(() => {
        _this.$router.push({path: '/login', replace: true})
      }, 600)
    }
    if (update) {
      // 更新列表
      _this.getList()
    }
    if (abnormal) {
      console.log(code)
    }
    if (_this.isLoading) {
      _this.isLoading = false
    }
    return new Promise((resolve) => {
      resolve()
    })
  },
  // 获取相关id数据
  getIdData (name, id, key) {
    if (id === null || id === undefined) {
      return ''
    }
    let data = typeof name === 'string' ? this[name] : name
    let value
    for (let val of data) {
      if (val.id === id * 1) {
        value = key ? val[key] : val
        break
      }
    }
    return value
  },
  // 获取日期
  getDate (a) {
    let time = new Date()
    let b = 24 * 60 * 60 * 1000
    time.setTime(time.getTime() - a * b)
    time = time.getFullYear() + '/' + (time.getMonth() + 1) + '/' + time.getDate()
    time = time.split('/')
    return time[0] + (time[1].length > 1 ? time[1] : '0' + time[1]) + (time[2].length > 1 ? time[2] : '0' + time[2])
  },
  // 切换列表或者编辑页
  switchListAndEdit  (_this, boolean) {
    _this.$router.push({path: _this.$route.path.replace(boolean ? '/edit' : '/list', boolean ? '/list' : '/edit')})
  },
  navigateTo (_this, toPath) {
    _this.$router.push({path: toPath})
  },
  // 获取当期日期 yyyMMdd 格式
  getNowDateYMD (code) {
    let date = code ? new Date(code) : new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let strDate = date.getDate()
    if (month >= 1 && month <= 9) {
      month = '0' + month
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = '0' + strDate
    }
    return `${year}${month}${strDate}`
  },
  // 获取当期日期 yyy-MM-dd hh:mm:ss 格式
  writeCurrentDate (code) {
    let now = new Date(code * 1000)
    let year = now.getFullYear()
    let month = now.getMonth()
    let date = now.getDate()
    let hour = now.getHours()
    let minu = now.getMinutes()
    let sec = now.getSeconds()
    let MS = now.getMilliseconds()
    month = month + 1
    if (month < 10) month = '0' + month
    if (date < 10) date = '0' + date
    if (hour < 10) hour = '0' + hour
    if (minu < 10) minu = '0' + minu
    if (sec < 10) sec = '0' + sec
    if (MS < 100) MS = '0' + MS
    return `${year}-${month}-${date} ${hour}:${minu}:${sec}`
  },
  // 获取当期日期 时间戳 格式
  // true: 00:00:00
  // false: 23:59:59
  getNowDateStamp (date, boolen) {
    let Y = parseInt(date[0] + date[1] + date[2] + date[3])
    let M = parseInt(date[4] + date[5]) - 1
    let D = parseInt(date[6] + date[7])
    let h = boolen ? 0 : 23
    let m = boolen ? 0 : 59
    let s = boolen ? 0 : 59
    return Date.parse(new Date(Y, M, D, h, m, s)) / 1000
  },
  // 10位时间戳转YYYY-MM-DD
  // 8位日期串转YYYY-MM-DD
  getTimeStampDate (code) {
    const date = code.length === 10 ? this.getNowDateYMD(new Date(parseInt(code) * 1000)) : code
    return `${date[0]}${date[1]}${date[2]}${date[3]}-${date[4]}${date[5]}-${date[6]}${date[7]}`
  },
  // JSON数据格式化展示
  getJsonData (json) {
    return this.getJsonDataTool(JSON.parse(json)).join('<br />')
  },
  // JSON数据格式化展示构造工具
  getJsonDataTool (data) {
    let arr = []
    let _null = ''
    let isArray = false
    if (data instanceof Array || data instanceof Object) {
      _null = '&nbsp;&nbsp;&nbsp;&nbsp;'
      if (data instanceof Array) {
        isArray = true
      }
    }
    for (let key in data) {
      let val = data[key]
      const type = typeof (val)
      if (type === 'string' || type === 'number' || type === 'boolean') {
        arr.push(isArray ? `${_null}${val}` : `${_null}<span style="font-weight: bold;color: #333">${key}：</span>${val}`)
      } else {
        let a = ''
        let b = ''
        if (val instanceof Array) {
          a = '['
          b = ']'
        } else if (val instanceof Object) {
          a = '{'
          b = '}'
        }
        arr.push(isArray ? `${_null}${a}` : `${_null}<span style="font-weight: bold;color: #333">${key}：</span>${a}`)
        const child = this.getJsonDataTool(val)
        for (let val of child) {
          arr.push(`${_null}${val}`)
        }
        arr.push(`${_null}${b}`)
      }
    }
    return arr
  },
  // 获取缓存的筛选数据
  getScreenData (_this, name) {
    const screen = window.sessionStorage.getItem(name)
    if (screen) {
      const data = JSON.parse(screen)
      for (let key in data) {
        const value = data[key]
        if (key === 'startPage') {
          _this.$store.state.user.currentPage = value
        } else if (key === 'pageSize') {
          _this.$store.state.user.pageSize = value
        } else {
          _this[key] = value
        }
      }
      window.sessionStorage.clear(name)
    }
  },
  restStartPage () {
    store.dispatch('SetCurrentPage', 1)
  },
  appendSelectAllItem (category, targetItems) {
    if (category === 'advertiser') {
      targetItems.unshift({advertiserId: '', advertiserName: '全部'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/myOption.js